// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FcBE","inner":"styles_inner__3SUPF","right":"styles_right__2t1-g","close":"styles_close__1y2ZR","footer":"styles_footer__2T2pz"};